<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div class="mt-1" v-else>
      <v-row>

        <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
          <div class="title_page ma-3">
            <h4 class="breadcrumb_title_page">สร้างรอบนับสต๊อก</h4>
            <v-breadcrumbs :items="sub_menu">
              <template v-slot:divider>
                <v-icon>mdi-chevron-right</v-icon>
              </template>
            </v-breadcrumbs>
          </div>
        </v-col>

      </v-row>
      <div class="mt-1">
        <v-card elevation="3" class="pa-4" style="border-radius: 15px;">
          <section class="pa-3">
            <v-row>
              <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                <div class="d-flex">
                  <div class="title_form_main">
                    <div class="logo_timeline">
                      <img src="@/assets/arin_assets/box.png">
                    </div>
                  </div>
                  <div class="header-content py-1 pl-5 pr-5 text-center">
                    <div class="content-font">การสร้างรอบนับสต๊อก</div>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-form ref="input_form" @submit.prevent="createCountStock()">
            <v-row>
              <v-col cols="6 pl-3">
                <div class="font-16">รอบนับครั้งที่ 0000{{ round_name }}</div>
              </v-col>
              <v-col cols="6 text-right">
                <div class="font-16">ผู้สร้างรอบนับ : {{ this.$store.state.store_arin.user_data.name }}</div>
              </v-col>
               <!-- <div class="text_title d-flex justify-space-between mt-3">
                    </div> -->
              <v-col xs="12" sm="6" md="4" lg="4" xl="4" cols="12" class="pa-3  py-0">
                <div class="text_title mt-2">วันที่นับสต๊อก <span class="red--text">*</span></div>
                <div class="mt-2">
                  <v-menu ref="menu_date" v-model="menu_date" :close-on-content-click="false"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field clearable class="input-radius" color="#D6BFAF" v-model="count_date" :rules="[v => !!v || 'กรุณาป้อนข้อมูล']"
                        prepend-inner-icon="mdi-calendar" placeholder="กรุณาเลือกวันที่นับสต๊อก" readonly v-bind="attrs" required
                        v-on="on" outlined dense></v-text-field>
                    </template>
                    <v-date-picker locale="TH" color="#D6BFAF" v-model="count_date" no-title :min="minDate" @change="menu_date = !menu_date"
                    scrollable></v-date-picker>
                  </v-menu>
                </div>
              </v-col>
              <v-col xs="12" sm="6" md="8" lg="8" xl="8" cols="12" class="pa-3 py-0 ">
                <div class="text_title mt-2">ผู้นับสต๊อก <span class="red--text">*</span></div>
                <div class="mt-2">
                  <v-autocomplete color="#D6BFAF" class="input-radius" v-model="user_count_stock_list"
                    :items="employess_list" item-text="name" item-value="id"
                    :rules="[v => !!v.length > 0 || 'กรุณาเลือกผู้นับสต๊อก']" hide-details="auto" label="กรุณาเลือกผู้นับสต๊อก"
                    small-chips chips multiple clearable outlined dense deletable-chips required></v-autocomplete>
                </div>
              </v-col>

              <v-col cols="12 mt-0 pa-3 pt-0">
                <div class="text_title">หมายเหตุ</div>
                <div class="mt-2">
                  <v-text-field v-model="note" color="#D6BFAF" class="input-radius" hide-details="auto"
                    placeholder="กรุณากรอกหมายเหตุ" outlined dense></v-text-field>
                </div>
              </v-col>
      

            </v-row>
            <div class="text-center mt-6 mb-3">
              <v-btn type="submit" height="45" class="white--text grad-success-arin-bg mobile_btn"
                style="font-size: 18px; border-radius: 10px;">บันทึก</v-btn>
            </div>
            </v-form>
          </section>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { minDate } from "@/js/handler";
import { HTTP_ARIN } from "@/axios_arin";
import Swal from "sweetalert2";
export default {
  inject: {
    theme: {
      default: {
        isDark: false,
      },
    },
  },
  name: "Admin_list",
  data() {
    return {
      loading_page: false,
      page_number: 1,
      search: '',
      footer_Props: {
        'items-per-page-text': 'รายการต่อหน้า'
      },
      sub_menu: [
        {
          text: 'ระบบ POS',
          disabled: false,
        },
        {
          text: 'คลังสินค้า',
          disabled: false,
        },
        {
          text: 'นับสต๊อก',
          disabled: false,
        },
        {
          text: 'สร้างรอบนับสต๊อก',
          disabled: false,
          href: '#',
        },
      ],
      menu_date: false,
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateEN: '',
      start_date: this.min_date(),
      minDate: new Date().toISOString().substr(0, 10),
      employess_list: [],
      user_count_stock_list: [],
      round_name: null,
      count_date: null,
      note: null,
    }
  },
  methods: {
    link(link) {
      window.location.href = link;
    },
    edit_employee() {
      this.$router.push('/arin/adminlist/editemployee')
    },
    detail_employee() {
      this.$router.push('/arin/adminlist/detailemployee')
    },
    async page(type) {
      // this.loading_page = true
      this.page_number = type
    },
    min_date: function () {
      return minDate()
    },
    async selectDate() {
      this.$refs.menu_date.save(this.date)
      this.menu_date = false
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0]) + 543
      const final_date = day + '/' + month + '/' + year
      return this.count_date = final_date
    },
    diffDateEN() {
      const diff = this.date.split('-')
      const year = parseInt(diff[2]) - 543
      const month = diff[1]
      const day = diff[0]
      return year + '-' + month + '-' + day
    },
    getEmployeeList() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/employee/detail/' + this.$store.state.store_arin.user_data.store_id, config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.employess_list = res.data.employeeList;
        }
      })
    },
    getCountingList() {
      const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
      HTTP_ARIN.get('/countstock/store/', config).then((res) => {
        if (res.data.successful === true) {
          this.loading_page = false;
          this.round_name = res.data.round_name;
        }
      })
    },
    createCountStock() {
     if(this.$refs.input_form.validate()){
       let config = {
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
        }
      };
      // const filteredData = data.filter(item => [6, 7].includes(item.id));
      const filteredData = this.employess_list.filter(item => this.user_count_stock_list.includes(item.id)).map(({ id, name }) => ({ id, name }));
      console.log(filteredData);
      let data = {
        "round_name": this.round_name,
        "count_date": this.count_date,
        "note": this.note,
        "user_count_stock_list": filteredData,
      }
      HTTP_ARIN.post('countstock/store/create', data, config)
        .then((res) => {
          if (res.data.successful === true) {
            let timerInterval
            Swal.fire({
              title: 'เสร็จสิ้น',
              text: 'เพิ่มข้อมูลรอบนับสต๊อกเรียบร้อยแล้ว',
              icon: 'success',
              timer: 2000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading()
                timerInterval = setInterval(() => { }, 100)
              },
              willClose: () => {
                clearInterval(timerInterval)
              }
              }).then((result) => {
                        /* Read more about handling dismissals below */
                        if (result.dismiss === Swal.DismissReason.timer) {
                            this.$router.push("/arin/pos/countingstocklist");
                        }
                    })
          } else {
            Swal.fire({
              title: 'ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง!',
              text: res.data.message,
              icon: 'error',
              showDenyButton: false,
              showCancelButton: false,
              confirmButtonText: `ตกลง`,
              denyButtonText: `ยกเลิก`,
            })
          }
        })
    }
     }
  },
  created() {
    const diff = this.date.split('-')
    const day = diff[2]
    const month = diff[1]
    const year = parseInt(diff[0]) + 543
    const final_date = day + '/' + month + '/' + year
    return this.date = final_date
  },
  mounted() {
    this.getEmployeeList();
    this.getCountingList();
  }
}
</script>

<style scoped>
.v-timeline::before {
  top: 55px;
  height: calc(100% - 80px);
}

.theme--light.v-timeline:before {
  background-color: #D6BFAF;
  width: 4px;
}

/* .header-content {
  margin-left: -15px;
  background: #f1e9e3;
  border: 1px solid #f1e9e3;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 0 30px 30px 0;
  margin-top: 2px;
  margin-bottom: 2px;
} */

.content-font {
  color: #616A6B;
  font-weight: 500;
  font-size: 16px;
}

.logo_timeline {
  width: 25px;
  height: 25px;
}

.logo_timeline>img {
  max-width: 25px;
}

.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.grid_half {
  display: grid;
  grid-template-columns: 45% 55%;
}

.radio_half {
  display: grid;
  grid-template-columns: 50%;
}

.v-otp-input .v-input {
  padding: 10px !important
}

.input-radius {
  border-radius: 10px;
}

.grid_radio {
  display: flex;
  justify-content: space-between;
}

.btn_width {
  width: 50%;
}

.image_half {
  display: grid;
  grid-template-columns: 40% 60%;
}

.input_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.mobile_btn {
  width: 15%;
}

.file_input_style {
  position: absolute;
  top: -25px;
  left: 265px;
  right: 0;
  bottom: 0;
}

.preview {
  border-radius: 10px;
}

.logo_admin {
  width: 80px;
  height: 80px;
}

.logo_admin>img {
  max-width: 80px;
}

.btn_width {
  width: 50%;
}

.input-radius {
  border-radius: 10px;
}

.text_header {
  color: #616A6B;
  font-weight: bold;
  font-size: 20px;
}

.text_header_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 22px;
}

/* ขนาด font 16 */
.font-16 {
  font-size: 16px !important;
}


.text_title {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.input_two_four {
  display: grid;
  grid-template-columns: 20% 40%;
}

.input_four_six {
  display: grid;
  grid-template-columns: 40% 60%;
}

.content-header-title {
  color: #616A6B;
  font-weight: 1000;
  font-size: 20px;
  display: flex;
  align-items: center;
}

.title_form_main {
  background: #D6BFAF;
  z-index: 2;
  border-radius: 50%;
  box-shadow: 0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);
  height: 38px;
  left: calc(50% - 19px);
  width: 38px;
}

.btn_detail_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #0F71B9 0%, rgba(136, 179, 88, 0) 100%), #8EBBDC !important;
  border-radius: 10px;
  width: 100%;
}

.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  width: 100% !important;
}
</style>
